import { combineReducers } from 'redux';
import dotMailerTrackerReducer from './dot-mailer-tracker-reducer';
import apiStatus from './api-status-reducer';

const rootReducer = combineReducers({
    dotMailerTracker: dotMailerTrackerReducer,
    apiStatus
});

export default rootReducer;
